import { __awaiter, __decorate, __extends, __generator } from "tslib";
import AbpBase from '@/lib/AbpBase';
import { Component, Prop } from 'vue-property-decorator';
import { UserServiceProxy } from '@/lib/service-proxy/service-proxies';
import Template from './SelectUserModal.html';
var SelectUserModal = /** @class */ (function (_super) {
    __extends(SelectUserModal, _super);
    function SelectUserModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.name = '';
        _this.users = [];
        _this.visible = false;
        _this.reloadUser = true;
        _this.allUsers = [];
        _this.totalCount = 0;
        _this.currentPage = 1;
        _this.pageSize = 10;
        _this.userService = new UserServiceProxy();
        return _this;
    }
    Object.defineProperty(SelectUserModal.prototype, "userColumns", {
        get: function () {
            var vm = this;
            var columns = [];
            if (!this.multiple) {
                columns.push({
                    key: 'actions',
                    title: '操作',
                    width: 100,
                    align: 'center',
                    render: function (h, params) {
                        var data = params.row;
                        return h('Button', {
                            props: {
                                size: 'small',
                                type: 'primary'
                            },
                            on: {
                                click: function () {
                                    if (vm.onSelected !== undefined) {
                                        vm.$emit('on-selected', params.row);
                                        vm.onSelected(params.row);
                                        vm.resolve([data]);
                                        vm.visible = false;
                                    }
                                }
                            }
                        }, '选择');
                    }
                });
            }
            else {
                columns.push({
                    type: 'selection',
                    width: 60,
                    align: 'center'
                });
            }
            columns.push({
                type: 'index',
                width: 80,
                align: 'center',
                indexMethod: function (row) {
                    return (vm.currentPage - 1) * vm.pageSize + row['_index'] + 1;
                }
            });
            columns.push({ key: 'userName', title: '用户名' });
            columns.push({ key: 'name', title: '姓名' });
            columns.push({ key: 'emailAddress', title: '邮箱' });
            return columns;
        },
        enumerable: true,
        configurable: true
    });
    SelectUserModal.prototype.created = function () {
        this.getUsers();
    };
    SelectUserModal.prototype.open = function () {
        var _this = this;
        this.visible = true;
        return new Promise(function (resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
    };
    SelectUserModal.prototype.getUsers = function () {
        return __awaiter(this, void 0, void 0, function () {
            var skip, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        skip = (this.currentPage - 1) * this.pageSize;
                        return [4 /*yield*/, this.userService.getUsers(this.name, undefined, undefined, 'name', this.pageSize, skip)];
                    case 1:
                        result = _a.sent();
                        this.allUsers = result.items;
                        this.totalCount = result.totalCount;
                        this.loading = false;
                        this.renderSelection();
                        return [2 /*return*/];
                }
            });
        });
    };
    SelectUserModal.prototype.pageChange = function (page) {
        this.currentPage = page;
        this.getUsers();
    };
    SelectUserModal.prototype.handleOkClick = function () {
        if (!this.users.length) {
            abp.message.error('未选择用户！');
            return;
        }
        this.$emit('on-selected', this.users);
        this.resolve(this.users);
        this.visible = false;
    };
    SelectUserModal.prototype.handelCancelClick = function () {
        this.users = [];
        this.reject('Select User Canceled!');
        this.visible = false;
    };
    SelectUserModal.prototype.renderSelection = function () {
        var _this = this;
        var listUsers = JSON.parse(JSON.stringify(this.allUsers));
        listUsers.forEach(function (item) {
            var index = _this.users.findIndex(function (selected) { return item.id === selected.id; });
            item['_checked'] = index !== -1;
        });
        this.reloadUser = false;
        this.$nextTick().then(function () {
            _this.allUsers = listUsers;
            _this.reloadUser = true;
        });
    };
    SelectUserModal.prototype.handleSelect = function (selection, checkedRow) {
        if (this.users.findIndex(function (c) { return c.id === checkedRow.id; }) === -1) {
            this.users.push(checkedRow);
        }
        this.renderSelection();
    };
    SelectUserModal.prototype.handleSelectAll = function (selection) {
        var _this = this;
        selection.forEach(function (user) {
            var index = _this.users.findIndex(function (c) { return c.id === user.id; });
            if (index === -1) {
                _this.users.push(user);
            }
        });
        this.renderSelection();
    };
    SelectUserModal.prototype.handleSelectCancel = function (selection, canceledRow) {
        var index = this.users.findIndex(function (c) { return c.id === canceledRow.id; });
        if (index !== -1) {
            this.users.splice(index, 1);
        }
        this.renderSelection();
    };
    SelectUserModal.prototype.handelSelectAllCancel = function (selection) {
        var _this = this;
        selection.forEach(function (user) {
            var index = _this.users.findIndex(function (c) { return c.id === user.id; });
            if (index !== -1) {
                _this.users.splice(index, 1);
            }
        });
        this.renderSelection();
    };
    SelectUserModal.prototype.handleSelectTagClose = function (event, id) {
        var index = this.users.findIndex(function (c) { return c.id === id; });
        if (index !== -1) {
            this.users.splice(index, 1);
        }
        this.renderSelection();
    };
    __decorate([
        Prop({
            type: [Boolean]
        })
    ], SelectUserModal.prototype, "multiple", void 0);
    __decorate([
        Prop({
            type: [Function],
            default: function () { return function () { }; }
        })
    ], SelectUserModal.prototype, "onSelected", void 0);
    __decorate([
        Prop({ type: [String], default: function () { return '选择用户'; } })
    ], SelectUserModal.prototype, "title", void 0);
    SelectUserModal = __decorate([
        Template,
        Component({
            name: 'SelectUserModal'
        })
    ], SelectUserModal);
    return SelectUserModal;
}(AbpBase));
export default SelectUserModal;
